//
import type { IDimeguidanceStore } from './dimeguidanceStore.model';

export const getDefaultState = (): IDimeguidanceStore => ({
  includeSpouse: false,
  dimeLoading: false,
  dimeCalculation: {
    you: {
      totalIncomeNeeded: 0,
      totalCashNeeded: 0,
      totalProtectionNeeded: 0,
    },
    spouse: {
      totalIncomeNeeded: 0,
      totalCashNeeded: 0,
      totalProtectionNeeded: 0,
    },
  },
  dimeData: {
    primary: {
      source: '',
      incomeGoal: 0,
      incomeFrequency: 0,
      yearsOfNeed: 0,
      mortgage: 0,
      debt: 0,
      education: 0,
      funeral: 0,
      rateOfReturn: 0,
      inflationRate: 0,
      adjustForInflation: '',
      existingIns: 0,
      includeExistingIns: '',
      spouseIncluded: '',
      totalInsNeed: 0,
      addlInsNeed: 0,
    },
    spouse: {
      source: '',
      incomeGoal: 0,
      incomeFrequency: 0,
      yearsOfNeed: 0,
      mortgage: 0,
      debt: 0,
      education: 0,
      funeral: 0,
      rateOfReturn: 0,
      inflationRate: 0,
      adjustForInflation: '',
      existingIns: 0,
      includeExistingIns: '',
      spouseIncluded: '',
      totalInsNeed: 0,
      addlInsNeed: 0,
    },
  },
});

const state = getDefaultState();

export default state;
